module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Regular.ee86ca24.woff2";